import { render, staticRenderFns } from "./PxElementQuestionEvaluationPanel.vue?vue&type=template&id=72c808e8&scoped=true"
import script from "./PxElementQuestionEvaluationPanel.vue?vue&type=script&lang=js"
export * from "./PxElementQuestionEvaluationPanel.vue?vue&type=script&lang=js"
import style0 from "./PxElementQuestionEvaluationPanel.vue?vue&type=style&index=0&id=72c808e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c808e8",
  null
  
)

export default component.exports